export default "__VITE_ASSET__BkWZ8uHD__"